import React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { ProductListLoan } from '@shared/components/sections/product-loans/ItemDescription'
import { Paths } from '@shared/menu-items/paths'
import { ComfortFormatBlock } from 'screens/partners/sections/comfort-format/view'
import Withdrawal from '@shared/svg/withdrawal.svg'
import Rub from '@shared/svg/rub.svg'
import Users from '@shared/svg/in-shape/users.svg'
import SingleUser from '@shared/svg/user.svg'
import Briefcase from '@shared/svg/in-shape/briefcase.svg'

export const mainBlock: MainBlock = {
	title: <>Партнёрская программа для кредитных брокеров</>,
	textItems: [
		'Вознаграждение — до 2% от суммы займа',
		'Поддержка менеджера на всех этапах',
		'Сделка под вашим полным контролем в личном кабинете',
	],
	buttonText: 'Стать партнёром',
	faceImageName: {
		mobile: 'Julia_mobile.png',
		default: 'Julia_desc.png',
	},
	imageAlt: 'Юлия, руководитель отдела по работе с партнерами',
	description: 'Для кредитных брокеров, физических и юридических лиц',
}

export const comfortBlocks: ComfortFormatBlock[] = [
	{
		id: 1,
		title: (
			<>
				Самостоятельное
				<br />
				сопровождение клиентов
			</>
		),
		Icon: Users,
		items: [
			'До 60 000 ₽ за сделку',
			'Сделка под полным контролем партнёра',
			'Для профессиональных кредитных брокеров, которые самостоятельно ведут клиентов от заявки и сбора документов до выдачи',
		],
		btnText: 'Стать партнёром',
		href: Paths.referralPartners,
	},
	{
		id: 2,
		title: (
			<>
				Реферальная
				<br />
				программа
			</>
		),
		Icon: Briefcase,
		items: [
			'До 20 000 ₽ за сделку',
			'Вся нагрузка по сделке — на Credit.Club: получаем заявку по реферальной ссылке и начинаем работу',
			'Для всех тех, кто готов привлекать заёмщиков: бухгалтеров на аутсорсе, страховых агентов, веб-мастеров, банковских сотрудников и т.д.',
		],
		btnText: 'Стать партнёром',
		href: Paths.referralPartners,
	},
]

export const productListLoan: ProductListLoan[] = [
	{
		id: 1,
		title: <>Доступны ставки на&nbsp;уровне банков</>,
		description: [
			'Без страховок',
			'Лояльны к кредитной истории',
			'Без скрытых платежей и комиссий',
		],
	},
	{
		id: 2,
		title: <>Срок&nbsp;— до&nbsp;20 лет</>,
		description: ['Для физических и юридических лиц', 'Решение за 1–2 рабочих дней'],
	},
	{
		id: 3,
		title: <>От 200 тысяч до&nbsp;15&nbsp;млн&nbsp;₽</>,
		description: ['Минимальный пакет документов', 'Не требуем справки о доходах'],
	},
]

export const stepsPartnersList = [
	{
		id: 1,
		text: 'Оставьте заявку',
		Icon: Rub,
	},
	{
		id: 2,
		text: 'Подпишите договор и пройдите мини-обучение',
		Icon: SingleUser,
	},
	{
		id: 3,
		text: 'Отправляйте заявки и получайте вознаграждение',
		Icon: Withdrawal,
	},
]

export const faqPartnersPage = [
	{
		title: 'Насколько быстрый процесс рассмотрения заявки?',
		content:
			'Деньги можем выдать в день обращения. Это возможно, если мы оперативно получаем требуемые документы от клиента и нам не требуется уточнение каких-либо деталей. Бывает, что выходим на сделку в течение 3–4 дней.',
	},
	{
		title: 'Важна ли кредитная история?',
		content:
			'Получение отказа из-за незначительных просрочек маловероятно. Мы детально изучаем каждую заявку и даём возможность каждому клиенту получить заём.',
	},
	{
		title: 'Не могу получить кредит в банке. Есть ли смысл подавать заявку у вас?',
		content:
			'Есть. Наша система скоринга менее формальна. Мы формируем собственный рейтинг, поэтому вероятность одобрения заявки на заём под залог недвижимости выше.',
	},
	{
		title: 'Требуется регулярное финансирование. Можете выдать средства по запросу?',
		content:
			'Да, у нас есть услуга — заёмная линия. Мы заключаем договор, устанавливаем лимит и по заявлению выдаём деньги.',
	},
	{
		title: 'Квартира сдаётся арендаторам. Нужно ли их выселять, чтобы получить заём?',
		content:
			'Да, у нас есть услуга — заёмная линия. Мы заключаем договор, устанавливаем лимит и по заявлению выдаём деньги.',
	},
	{
		title:
			'Сколько этажей должно быть в жилом доме, чтобы вы рассмотрели заявку на заём под залог квартиры?',
		content:
			'Да, у нас есть услуга — заёмная линия. Мы заключаем договор, устанавливаем лимит и по заявлению выдаём деньги.',
	},
]
